import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DefaultIndicatorState {
  isLoading: boolean
  error: string | undefined
  data: any
  httpStatus: number | undefined
}

export const initialState: DefaultIndicatorState = {
  isLoading: false,
  error: undefined,
  data: null,
  httpStatus: 0
}

const addDefaultIndicatorSlice = createSlice({
  name: 'AddDefaultIndicatorSlice',
  initialState,
  reducers: {
    addDefaultIndicatorLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: null,
        httpStatus: 0
      }
    },
    addDefaultIndicatorUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    addDefaultIndicatorErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: null,
        httpStatus: action.payload.httpStatus
      }
    },
    defaultIndicatorReset: () => initialState
  }
})

export const {
  addDefaultIndicatorLoadingAction,
  addDefaultIndicatorUpdateAction,
  addDefaultIndicatorErrorAction,
  defaultIndicatorReset
} = addDefaultIndicatorSlice.actions

export default addDefaultIndicatorSlice.reducer
